<script setup lang="ts">
import { AkButton, AkIcon } from '@ankorstore/design-system';
import { getStaticAssetUrl } from '@bc/shared/util';

defineProps<{
  brandName: string;
}>();

defineEmits<{
  login: [];
  register: [];
}>();
</script>

<template>
  <div class="referral-header">
    <div class="referral-header__left">
      <span class="referral-header__brand-name">{{ brandName }}</span>
      <AkIcon
        symbol="x"
        size="md"
        class="referral-header__separator"
      />
      <img
        :src="getStaticAssetUrl('/images/logo/logo-black.svg')"
        :alt="$t('ankorstore')"
        class="referral-header__logo referral-header__logo--desktop"
      >
      <img
        :src="getStaticAssetUrl('/images/logo/logo-small-black.svg')"
        :alt="$t('ankorstore')"
        class="referral-header__logo referral-header__logo--mobile"
      >
    </div>
    <div class="referral-header__actions">
      <AkButton
        link
        size="md"
        class="referral-header__login-btn"
        @click="$emit('login')"
      >
        {{ $t('Login') }}
      </AkButton>
      <AkButton
        size="md"
        class="referral-header__register-btn"
        @click="$emit('register')"
      >
        {{ $t('referral.header.registerToBuy.cta') }}
      </AkButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.referral-header {
  @apply ds-mx-auto ds-flex ds-items-center ds-justify-between ds-px-4 lg:ds-px-6 ds-py-3 ds-border-b ds-border-solid ds-border-neutral-300;
  max-width: 1600px;

  &__left {
    @apply ds-flex ds-items-center ds-gap-1 lg:ds-gap-2;
  }

  &__brand-name {
    @apply ds-font-basic ds-font-bold ds-text-primary ds-text-base;
  }

  &__separator {
    @apply ds-text-neutral-600;
  }

  &__logo {
    @apply ds-h-6;

    &--desktop {
      @apply ds-hidden lg:ds-block;
    }

    &--mobile {
      @apply ds-block ds-w-[48px] lg:ds-hidden;
    }
  }

  &__actions {
    @apply ds-hidden lg:ds-flex ds-items-center ds-gap-5;
  }

  &__login-btn {
    @apply ds-underline;
  }

  &__register-btn {
    @apply ds-p-2;
  }
}
</style>
